class LocalStorageService {
  setItem(key, value) {
    if (typeof value === "object") {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  }

  getItem(key) {
    const value = localStorage.getItem(key);
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  removeItem(key) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }

  resetFormData() {
    localStorage.removeItem("form-data");
  }

  getFormData() {
    const value = localStorage.getItem("form-data");
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  setFormData(value) {
    if (typeof value === "object") {
      value = JSON.stringify(value);
      localStorage.setItem("form-data", value);
    }
  }

  resetFormResults() {
    localStorage.removeItem("form-results");
  }

  getFormResults() {
    const value = localStorage.getItem("form-results");
    try {
      return JSON.parse(value);
    } catch (e) {
      return value;
    }
  }

  setFormResults(value) {
    if (typeof value === "object") {
      value = JSON.stringify(value);
      localStorage.setItem("form-results", value);
    }
  }

  setCacheWithExpiry(key, value, expiryMinutes = 20) {
    const now = new Date();
    const item = {
      value: typeof value === "object" ? JSON.stringify(value) : value,
      expiry: now.getTime() + expiryMinutes * 60000,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  getCache(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }
    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    this.clearCache(key);
    return JSON.parse(item.value);
  }

  clearCache(key) {
    localStorage.removeItem(key);
  }

  displayCachedData(key) {
    const data = this.getCache(key);
    if (data) {
      console.log(data);
      this.clearCache(key);
    } else {
      localStorage.log("Data tidak ditemukan atau sudah expired.");
    }
  }
}

export default new LocalStorageService();
